
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { AttachmentList, AttachmentBox } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Attachment list`}</h1>
<p>{`Use in conjunction with the `}<a parentName="p" {...{
        "href": "/component-kit/components/attachment-box"
      }}><inlineCode parentName="a">{`AttachmentBox`}</inlineCode></a>{` component, to display a list of attachments.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { AttachmentList } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<div style={{ width: 400 }}>
  <AttachmentList>
    <AttachmentBox fileName="File1.jpg" onClickClose={() => {}} />
    <AttachmentBox fileName="File2.svg" onClickClose={() => {}} />
    <AttachmentBox fileName="File4.mov" onClickClose={() => {}} />
  </AttachmentList>
</div>`} component={AttachmentList} mdxType="Playground">
  <div style={{
        width: 400
      }}>
    <AttachmentList mdxType="AttachmentList">
      <AttachmentBox fileName="File1.jpg" onClickClose={() => {}} mdxType="AttachmentBox" />
      <AttachmentBox fileName="File2.svg" onClickClose={() => {}} mdxType="AttachmentBox" />
      <AttachmentBox fileName="File4.mov" onClickClose={() => {}} mdxType="AttachmentBox" />
    </AttachmentList>
  </div>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;